import { IPaginationEntity } from './pagination.entity';

export class PaginationDto {
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;

  constructor(pagination: IPaginationEntity) {
    this.page = pagination.page_number;
    this.hasNextPage = pagination.page_number < pagination.total_pages;
    this.totalPages = pagination.total_pages;
    this.hasPreviousPage = pagination.page_number > 1;
    this.limit = pagination.page_size;
  }
}
